<script setup>
  import { useLocale } from 'vuetify'
  const { current } = useLocale()
  const local = localStorage.getItem('locale')
  if(!local){
      localStorage.setItem('locale',current.value);
  }else{
      localStorage.setItem('locale',local);
      current.value = local
  }
</script>

<template>
     <footer class="pb-5" :key="hasSettings">
      <v-divider></v-divider>
      <v-container class="py-5">
       <v-row class="h-100" align="center">
          <v-col cols="12">
              <v-row align="center">
                <v-col cols="12" md="4" class="text-center text-md-start">
                  <v-img height="45" width="100%" src="@/assets/loghi/logotipo.svg" :alt="$env.VITE_APP_BASE_NAME"></v-img>
                </v-col>
                <v-col cols="12" md="4" class="text-center text-md-start">
                  <v-img height="45" width="100%" src="/logo-hertz.png" :alt="$env.VITE_APP_BASE_NAME"></v-img>
                </v-col>
                <v-col cols="12" md="4" class="text-center"  v-if="social">
                  <v-btn-toggle
                    color="primary"
                    class="mx-auto"
                    v-if="social[locale]"
                    variant="plain"
                  >
                    <v-btn 
                      v-for="(item, i) in social[locale].value" 
                      :key="i"
                      :href="item.link"
                      :id="item.title+'-social-link'"
                      :title="item.title+' - '+i+' social-link'"
                      target="_blank">
                      
                       <v-img v-if="(item.image)" :src="item.image.url" width="40px" height="40px"></v-img>
                       <v-icon v-else width="40px" height="40px" >{{item.icon}}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="12" md="4" class="text-center">
                  <locale-chooser></locale-chooser>
                </v-col>
                <v-col cols="12"  v-if="footer" class="text-center">
                  <div v-if="footer[locale]">
                    <v-btn   
                      v-for="(item,i) in footer[locale].value" 
                      :key="i" 
                      size="small" 
                      :to="(item.route) ? item.route : item.link"
                      target="_blank"
                      variant="plain"
                      >
                      {{ item.text }}
                    </v-btn>
                    <br>
                    <span class="text-caption text-medium-emphasis">Prime S.R.L. Via Flaminia Vecchia 491, 00191 - Roma</span>
                    <br />
                    <span class="text-caption text-medium-emphasis">
                      <a href="mailto:info@primerentcar.com">info@primerentcar.com</a>
                    </span>
                    <span class="mx-3">-</span>
                    <span class="text-caption text-medium-emphasis">
                      <a href="tel:+390633220167">+39 06 3322 0167</a>
                    </span>
                  </div>
                </v-col>
              </v-row>
          </v-col>
       </v-row>
      </v-container>
      <!-- <CookieBanner :remoteOpener="openCookie" /> -->
     </footer>
</template>
   
<script>
import { mapGetters } from 'vuex';
import LocaleChooser from './LocaleChooser.vue';
// import CookieBanner from './CookieBanner.vue';

export default {
  name: 'AppFooter',
  components:{
    'locale-chooser': LocaleChooser,
    // 'CookieBanner': CookieBanner
  },
  computed:{
      ...mapGetters({
          hasSettings: 'settings/hasSettings',
          footer: 'settings/footer',
          social: 'settings/social',
      })
  },
  data: () => ({
    locale: localStorage.getItem('locale'),
    openCookie: null,
  }),
  watch:{
    
  },
  mounted(){
        if(!['en','it'].includes(this.locale)){
          this.locale = 'en';
        }
       
  },
  methods:{
    viewCookie(val){  
        if(val){
          this.openCookie = Math.random();
        }
    } 
  }
}
</script>
